import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';
import { isEmpty, pathOr } from 'ramda';
import { getCurrentLabelsJson } from '../labels/labels.selector';
import { flowType, queryAmount, walletProvider } from '../query-params/query-param.selectors';
import { getFxRateFromQuote, summarySectionConfig } from './fee-quote-utils';
import { FxRateMockData } from './fee-quote.mock';
import { FeeQuoteData, FeeQuoteState, FxRateDetails } from './types';

const getFeeQuoteState = createFeatureSelector<FeeQuoteState>('feeQuoteState');

export const selectFeeQuoteState = createSelector(
  getFeeQuoteState,
  (state: FeeQuoteState) => state.feeQuoteData
);

export const selectFeeQuoteError = createSelector(
  getFeeQuoteState,
  (state: FeeQuoteState) => {
    // console.log('ERRORRR : ', state?.errors);
    return pathOr(null, ['errors', 'errors', '0'], state);
  }
);

export const getFxRateDetails = createSelector(
  getFeeQuoteState,
  (state: FeeQuoteState) => state.fxRateDetails.fxRates
);

export const getUserTrnAmount = createSelector(
  getFeeQuoteState,
  (state: FeeQuoteState) => state?.transactionAmount
);

export const isWalletFeeEnabled = createSelector(
  selectFeeQuoteState,
  flowType,
  (state: FeeQuoteData, flow: string) => ((flow === 'deposit' && state?.cashInWalletFeeEnabled) || (flow === 'withdraw' && state?.cashOutWalletFeeEnabled))
);

export const getFxRate = createSelector(
  getFxRateDetails,
  selectFeeQuoteState,
  flowType,
  (state: FxRateDetails[], quote: FeeQuoteData, flow: string) => {
    if (!isEmpty(quote.transactions)) {
      return getFxRateFromQuote(quote, flow);
    } else if (!!state) {
      return {
        fxRate:
          flow === 'deposit'
            ? state[0]?.fxRateInverted || 0
            : state[0]?.fxRate || 0,
        currency:
          flow === 'deposit'
            ? state[0]?.sendCurrencyCode || 'USD'
            : state[0]?.receiveCurrencyCode || 'USD',
      };
    }
    return FxRateMockData;
  }
);


export const getAmoutSummary: MemoizedSelector<FeeQuoteData, any> =
  createSelector(
    selectFeeQuoteState,
    flowType,
    getCurrentLabelsJson,
    walletProvider,
    (state, flow, labels, walletProvider) =>
      summarySectionConfig(state, flow, labels.labels, walletProvider)
  );

  export const getFxrateSummary: MemoizedSelector<FeeQuoteData, any> = createSelector(
    getUserTrnAmount,
    queryAmount,
    flowType,
    getFxRateDetails,
    (trnAmount, qAmount, flow, fxRate) => {
        // console.log("YYY fxRRRATAe : ", fxRate)
        return {
            amount: trnAmount || qAmount || 10, // SAS team suggest to pass 10 as default 
            curency: flow === 'deposit' ? fxRate[0]?.receiveCurrencyCode : 'USD',
            // fxrate: pathOr(null, ['0'], fxRate)
            fxRate: {
                serviceOptionCode: "WILL_CALL",
                serviceOptionName: "10 Minute Service",
                sendCurrencyCode: "USD",
                receiveCurrencyCode: fxRate[0]?.receiveCurrencyCode,
                fxRate: fxRate[0]?.fxRate,
                fxRateEstimated: true
            }
        }
    }
);

